<template>
<div>
    <div class="spin-container">
        <div class="q-spinner"></div>
        <p>Preparing question...</p>
    </div>
    <div>
        <b-modal ref="my-modal" hide-footer title="" :no-close-on-backdrop="true" :no-close-on-esc="true" backdrop='static'>
        <div class="d-block text-center">
            <h8><b>Error may have occured while forming the question</b>,<br/> please refresh and follow the questions in <b style="color: red;">sequential order</b>.</h8>
        </div>
        <b-button class="mt-3" variant="outline-danger" block @click="hideModal">Refresh</b-button>
        </b-modal>
    </div>
    </div>
</template>
<script>
import router from "@/router";

export default {
    data: () => ({

    }),
    methods: {
      hideModal () {
        router.push({ name: "landing" });
        this.$refs['my-modal'].hide();
      }
    },
    mounted () {
        const me = this;
        if (me.$refs['my-modal'] != undefined) {
          setTimeout(() => { me.$refs['my-modal'].show(); }, 25000);
        }
      }
    };
</script>
<style scoped>
.spin-container {
    position: absolute;
    top: 5px;
    bottom: -5px;
    left: 0;
    right: 0;
    background-color: #d9e2f3; /* keep in sync with expansion-panel-content__wrap */
    z-index: 10;
}
.spin-container > p {
    text-align: center;
    font-weight: bold;
    margin: 0;
    font-size: 32px;
}
.q-spinner {
  height: 250px;
  width: 250px;
  border: 3px solid transparent;
  border-radius: 50%;
  border-top: 4px solid #4d5b9b;
  -webkit-animation: spin 4s linear infinite;
  animation: spin 4s linear infinite;
  position: relative;
  margin: 50px auto;
}

.q-spinner::before,
.q-spinner::after {
  content: "";
  position: absolute;
  top: 6px;
  bottom: 6px;
  left: 6px;
  right: 6px;
  border-radius: 50%;
  border: 4px solid transparent;
}

.q-spinner::before {
  border-top-color: #17a2b8;
  -webkit-animation: 3s spin linear infinite;
  animation: 3s spin linear infinite;
}

.q-spinner::after {
  border-top-color: #1976d2;
  -webkit-animation: spin 1.5s linear infinite;
  animation: spin 1.5s linear infinite;
}

@-webkit-keyframes spin {
    from {
        -webkit-transform: rotate(0deg);
         transform: rotate(0deg);
    }
    to {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}

@keyframes spin {
    from {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    to {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}
</style>
